import {
  AdminZoneIcon,
  BarChartIcon,
  CalendarIcon,
  DocumentIcon,
  GoalIcon,
  GraduationHatIcon,
  MoneyIcon,
  NotesIcon,
  ReportIcon,
  ShoppingBagIcon,
  StoreIcon,
  TargetIcon,
  UserIcon,
  VillageIcon,
  YesOrNoIcon,
  EuroIcon,
  WebsiteIcon,
  InfoCircleOutlined,
} from '../icons';

export const links = {
  admin: '/admin',
  users: '/sso',
  salesTracking: '/sales_trackings',
  promo: '/promo',
  boardDocs: '/boarddocs',
  documents: '/documents',
  chooseCompany: '/choose_company',
  mistery: '/mistery',
  cv: '/cv',
  finance: '/finance',
  myPriorityAdmin: 'https://api.mypriority.shop/admin/login',
  facility: '/facility',
  retailAcademy: '/retail_academy',
  analytics: '/analytics',
  interviews: '/interviews',
  clickCollect: '/click_collect',
  leasing: '/leasing',
  website: '/website',
};

export const paths = {
  home: '/',
  smartShopping: '/click_collect/*',
  userConfirmation: '/sso/users/confirmation/*',
  admin: '/admin/*',
  login: '/login',
  users: '/sso/*',
  salesTracking: '/sales_trackings/*',
  promo: '/promo/*',
  boardDocs: '/boarddocs/*',
  documents: '/documents/*',
  chooseCompany: '/choose_company/*',
  mistery: '/mistery/*',
  cv: '/cv/*',
  finance: '/finance/*',
  facility: '/facility/*',
  retailAcademy: '/retail_academy/*',
  analytics: '/analytics/*',
  interviews: '/interviews/*',
  forgotPassword: '/password-recover/*',
  emergencyContactsConfirm: 'emergency_contacts/confirm/:token',
  leasing: '/leasing/*',
  website: '/website/*',
  companiesForQr: '/companies/:id',
  vacancies: '/vacancies',
};

const pages = [
  {
    Icon: AdminZoneIcon,
    title: 'Zona Admin',
    basePath: '/admin',
    link: links.admin + '/shopping_centers',
    slug: 'admin',
    type: 'halfDone',
    main: 'Zona admin',
    hideMain: true,
    subLinks: [
      {
        value: 'admin.shopping.center',
        title: 'Outlet Village',
        link: `${links.admin}/shopping_centers`,
        slug: 'admin/shopping_centers',
      },
      {
        title: 'Categorie insegne',
        link: `${links.admin}/company_categories`,
        slug: 'admin/company_categories',
      },
      {
        title: 'Categorie Sito',
        link: `${links.admin}/site_categories`,
        slug: 'admin/site_categories',
      },
      {
        title: 'Sottocategorie',
        link: `${links.admin}/company_child_categories`,
        slug: 'admin/company_child_categories',
      },
      {
        title: 'Segmento',
        link: `${links.admin}/prestige_levels`,
        slug: 'admin/prestige_levels',
      },
      {
        title: 'Catene',
        link: `${links.admin}/chains`,
        slug: 'admin/chains',
      },
      {
        title: 'Insegne',
        link: `${links.admin}/companies`,
        slug: 'admin/companies',
      },
      {
        title: 'Testi Myshop',
        link: `${links.admin}/pages`,
        slug: 'admin/pages',
      },
      {
        title: 'Logs',
        link: `${links.admin}/gdprlogs`,
        slug: 'admin/logs',
      },
      {
        title: 'Footfall del Village',
        link: `${links.admin}/footfalls`,
        slug: 'admin/footfalls',
      },
      {
        link: `${links.admin}/calendars`,
        slug: 'admin/analytics_calendars',
        title: 'Footfall e calendario',
      },
      {
        link: 'my_priority',
        slug: 'my_priority',
        title: 'MyPriority — amministrazione',
        openNewTab: true,
      },
      {
        link: `${links.admin}/choose_companies`,
        slug: 'my_priority_admin',
        title: 'MyPriority',
      },
      {
        title: 'Agenti',
        link: `${links.admin}/agents`,
        slug: 'admin/agents',
      },
      // {
      //   title: 'Notifications',
      //   link: `${links.admin}/notifications`,
      //   slug: 'admin/notifications',
      // },
      // {
      //   title: 'Smart Shopping',
      //   link: `${links.admin}/click_collect`,
      //   slug: 'admin/click_collect',
      // },
    ],
  },
  {
    type: 'halfDone',
    Icon: UserIcon,
    title: 'Utenti',
    link: '/sso/users',
    basePath: '/sso',
    hideMain: true,
    slug: 'sso',
    subLinks: [
      {
        title: 'Utenti',
        link: '/sso/users',
        slug: 'sso/users',
      },
      {
        title: '',
        link: '/sso/users/confirmation',
        slug: 'sso/users/confirmation',
      },
      {
        title: 'Permessi',
        link: '/sso/user_roles/page',
        slug: 'sso/user_roles',
      },
      {
        title: 'Notifiche',
        link: '/sso/notification/page',
        slug: 'sso/notifications',
      },
    ],
  },
  {
    Icon: TargetIcon,
    title: 'Sales Tracking',
    type: 'done',
    link: links.salesTracking,
    basePath: '/sales_trackings',
    slug: 'sales_trackings',
    main: 'Sales Tracking',
    hideMain: true,
    subLinks: [
      {
        title: 'Sales tracking',
        link: '/sales_trackings',
        slug: 'sales_trackings',
      },
    ],
  },
  {
    type: 'halfDone',
    Icon: VillageIcon,
    title: 'Iniziative Village',
    link: '/promo/promotions',
    basePath: '/promo',
    hideMain: true,
    slug: 'promo',
    subLinks: [
      {
        title: 'Promozioni',
        link: '/promo/promotions',
        slug: 'promo/promotions',
      },
      {
        title: 'Eventi e novità',
        link: '/promo/store_events',
        slug: 'promo/store_events',
      },
      {
        title: 'Product gallery',
        link: '/promo/products',
        slug: 'promo/products',
      },
      {
        title: 'Brand page',
        link: '/promo/brands',
        slug: 'promo/brands',
      },
      {
        title: 'Coupon',
        link: '/promo/coupons',
        slug: 'promo/coupons',
      },
      {
        title: 'QR code',
        link: '/promo/qrs',
        slug: 'promo/qrs',
      },
      {
        title: 'Attività per fascia oraria',
        link: '/promo/extrasales',
        slug: 'promo/extrasales',
      },
      {
        title: 'Calendario prenotazioni',
        link: '/promo/calendar',
        slug: 'promo/extrasales/calendar',
      },
    ],
  },
  {
    type: 'halfDone',
    Icon: NotesIcon,
    title: 'Bacheca',
    link: links.boardDocs + '/weekly',
    basePath: links.boardDocs,
    slug: 'wiki',
    main: 'Pubblica Documento',
    hideMain: true,
    subLinks: [
      {
        title: 'Pubblica documento',
        link: links.boardDocs + '/weekly/new',
        slug: 'wiki/boarddocs/new',
        withParams: true,
      },
      {
        title: 'Circolari',
        slug: 'wiki/boarddocs?category=circulars',
        link: links.boardDocs + '/circulars',
        withParams: true,
      },
      {
        title: 'Classifiche settimanali',
        link: links.boardDocs + '/weekly',
        slug: 'wiki/boarddocs?category=weekly',
        withParams: true,
      },
      {
        title: 'Classifiche mensili',
        link: links.boardDocs + '/monthly',
        slug: 'wiki/boarddocs?category=monthly',
        withParams: true,
      },
      {
        title: 'Comunicati amministrativi',
        slug: 'wiki/boarddocs?category=admin_releases',
        link: links.boardDocs + '/admin_releases',
        withParams: true,
      },
      {
        title: 'Manuali Village',
        slug: 'wiki/boarddocs?category=manuals',
        link: links.boardDocs + '/manuals',
        withParams: true,
      },
      {
        title: 'Convenzioni e promo dipendenti',
        link: links.boardDocs + '/promotions',
        slug: 'wiki/boarddocs/promotions',
        withParams: true,
      },
    ],
  },
  {
    type: 'halfDone',
    Icon: DocumentIcon,
    title: 'Documenti',
    link: links.documents + '/company_documents',
    basePath: links.documents,
    hideMain: true,
    slug: 'documents',
    main: 'Documenti',
    subLinks: [
      {
        title: 'Documenti',
        link: `${links.documents}/company_documents`,
        slug: 'documents/company_documents',
      },
      {
        title: 'Categorie documenti',
        link: `${links.documents}/company_document_categories`,
        slug: 'documents/company_document_categories',
      },
    ],
  },
  {
    type: 'done',
    Icon: ReportIcon,
    title: 'Mystery Report',
    link: links.mistery + '/mistery_reports',
    basePath: links.mistery,
    hideMain: true,
    slug: 'mistery',
    main: 'Mystery Report',
    subLinks: [
      {
        title: 'Mystery Report',
        link: links.mistery + '/mistery_reports',
        openNewTab: false,
        slug: 'mistery/mistery_reports',
      },
      {
        title: 'Dashboard',
        link: 'https://europe.sassieshop.com/2doxa/clients/LoginClient.norm.php',
        openNewTab: true,
        slug: 'dashboard',
      },
    ],
  },
  {
    type: 'halfDone',
    Icon: GoalIcon,
    title: 'Career',
    link: links.cv + '/vacancies',
    basePath: links.cv,
    hideMain: true,
    slug: 'cv',
    subLinks: [
      {
        title: 'Settore',
        link: `${links.cv}/vacancy_application_types`,
        slug: 'cv/vacancy_application_types',
      },
      {
        title: 'Profilo candidato',
        link: `${links.cv}/vacancy_categories`,
        slug: 'cv/vacancy_categories',
      },
      {
        title: 'Anni di esperienza',
        link: `${links.cv}/experience_years`,
        slug: 'cv/experience_years',
      },
      {
        title: 'Disponibilità contratto',
        link: `${links.cv}/contract_types`,
        slug: 'cv/contract_types',
      },
      {
        title: 'Lingue',
        link: `${links.cv}/vacancy_languages`,
        slug: 'cv/vacancy_languages',
      },
      {
        title: 'Database candidati',
        link: `${links.cv}/candidates`,
        slug: 'cv/candidates',
      },
      {
        title: 'Annunci online',
        link: `${links.cv}/vacancies`,
        slug: 'cv/vacancies',
      },
      {
        title: 'Candidature annunci',
        link: `${links.cv}/vacancy_applications`,
        slug: 'cv/vacancy_applications',
      },
      {
        title: 'Candidature spontanee',
        link: `${links.cv}/auto`,
        slug: 'cv/candidates/auto',
      },
      {
        title: 'Adesione privacy',
        link: `${links.cv}/user_vacancies`,
        slug: 'cv/user_vacancies',
      },
      {
        title: 'Log GDPR',
        link: `${links.cv}/customer_logs`,
        slug: 'cv/customer_logs',
      },
    ],
  },
  {
    Icon: MoneyIcon,
    title: 'Fatturati',
    link: `${links.finance}/invoices`,
    basePath: links.finance,
    hideMain: true,
    slug: 'finance',
    type: 'halfDone',
    subLinks: [
      {
        title: 'Fatturato settimanale',
        link: `${links.finance}/invoices`,
        slug: 'finance/invoices',
      },
      {
        title: 'Fatturato da approvare',
        link: `${links.finance}/blank-invoices`,
        slug: 'finance/blank-invoices',
      },
      {
        title: 'Fatturato mensile',
        link: `${links.finance}/invoice_monthlies`,
        slug: 'finance/invoice_monthlies',
      },
      {
        title: 'Fatturato semestrale/annuale',
        link: `${links.finance}/invoice_years`,
        slug: 'finance/invoice_years',
      },
      {
        title: 'Fatturato certificato',
        link: `${links.finance}/certificateds`,
        slug: 'finance/invoices_certificateds',
      },
    ],
  },
  {
    Icon: StoreIcon,
    title: 'Facility',
    link: `${links.facility}/requests`,
    basePath: links.facility,
    hideMain: true,
    type: 'halfDone',
    slug: 'facility',
    subLinks: [
      {
        title: 'Aperture/Chiusure',
        link: `${links.facility}/requests`,
        slug: 'facility/facility_request',
      },
      {
        title: 'Extrastock Unit',
        link: `${links.facility}/extrastocks`,
        slug: 'facility/extrastocks',
      },
      {
        title: 'Richieste Extrastock',
        link: `${links.facility}/extrastock_offers`,
        slug: 'facility/extrastock_offers',
      },
      {
        title: 'Extrastock contractors',
        link: `${links.facility}/extrastock_contractors`,
        slug: 'facility/extrastock_contractors',
      },
      {
        title: 'Facility contractors',
        link: `${links.facility}/contractors`,
        slug: 'facility/contractors',
      },
      {
        title: 'Intervento facility',
        link: `${links.facility}/operations`,
        slug: 'facility/operations',
      },
      {
        title: 'Contatti di emergenza',
        link: `${links.facility}/emergency_contacts`,
        slug: 'facility/emergency_contacts',
      },
      {
        title: 'Calendario facility',
        link: `${links.facility}/calendar`,
        slug: 'facility/calendar',
      },
      {
        title: 'Waiting list',
        link: `${links.facility}/waiting_lists`,
        slug: 'facility/waiting_list',
      },
    ],
  },
  {
    type: 'done',
    Icon: CalendarIcon,
    title: 'Scheda Insegna',
    link: '/admin/companies',
    slug: 'scheda_insegna',
  },
  {
    type: 'done',
    Icon: GraduationHatIcon,
    title: 'Retail academy',
    link: `${links.retailAcademy}/academy_articles`,
    basePath: links.retailAcademy,
    hideMain: true,
    slug: 'retail_academy',
    subLinks: [
      {
        title: 'Capitoli',
        link: `${links.retailAcademy}/academy_articles`,
        slug: 'retail_academy/academy_articles',
      },
      {
        title: 'Modulo retail academy',
        link: `${links.retailAcademy}/academy_categories`,
        slug: 'retail_academy/academy_categories',
      },
      {
        title: 'Logs',
        link: `${links.retailAcademy}/logs`,
        slug: 'retail_academy/logs',
      },
    ],
  },
  {
    type: 'done',
    Icon: BarChartIcon,
    title: 'Business Analitics',
    link: `${links.analytics}/footfall`,
    basePath: links.analytics,
    hideMain: true,
    slug: 'business_analytics',
    subLinks: [
      // {
      //   title: 'Analytics calendar',
      //   link: `${links.analytics}/calendars`,
      //   withParams: true,
      //   slug: 'business_analytics/analytics_calendars',
      // },
      // {
      //   title: 'Trading calendar',
      //   link: `${links.analytics}/calendar_categories`,
      //   slug: 'business_analytics/analytics_calendar_category',
      //   withParams: true,
      // },
      {
        title: 'Footfall',
        link: `${links.analytics}/footfall`,
        slug: 'business_analytics/footfall',
        withParams: true,
      },
      {
        title: 'Sales',
        link: `${links.analytics}/invoices_sales_village`,
        slug: 'business_analytics/sales',
        withParams: true,
      },
      {
        title: 'Footfall & Sales',
        link: `${links.analytics}/invoices_compare_footfall_sales`,
        slug: 'business_analytics/footfall_sales',
        withParams: true,
      },
      {
        title: 'Conversion Rate vs LY',
        link: `${links.analytics}/invoices_conversion_rate_village`,
        slug: 'business_analytics/conversion_rate',
        withParams: true,
      },
      {
        title: 'ATV vs LY',
        link: `${links.analytics}/invoices_atv_village`,
        slug: 'business_analytics/atv',
        withParams: true,
      },
      {
        title: 'UPT vs LY',
        link: `${links.analytics}/invoices_upt_village`,
        slug: 'business_analytics/upt',
        withParams: true,
      },
      {
        title: 'Items sold',
        link: `${links.analytics}/invoices_pieces`,
        slug: 'business_analytics/pieces',
        withParams: true,
      },
      {
        title: 'Tickets',
        link: `${links.analytics}/invoices_tickets`,
        slug: 'business_analytics/tickets',
        withParams: true,
      },
      {
        title: 'Overview KPIs',
        link: `${links.analytics}/kpi`,
        slug: 'business_analytics/kpi',
        withParams: true,
      },
      {
        title: 'KPIs by DAY TYPE',
        link: `${links.analytics}/weekdays_holidays_kpi`,
        slug: 'business_analytics/kpi_weekdays_holidays',
        withParams: true,
      },
      {
        title: 'Sales by Category / Sales',
        link: `${links.analytics}/consumi_net_sales`,
        slug: 'business_analytics/consumi_net_sales',
        withParams: true,
      },
      {
        title: 'Sales by Category / Items',
        link: `${links.analytics}/invoices_category_pieces`,
        slug: 'business_analytics/consumi_pieces',
        withParams: true,
      },
      {
        title: 'Sales by Category / Tickets',
        link: `${links.analytics}/invoices_category_tickets`,
        slug: 'business_analytics/consumi_tikets',
        withParams: true,
      },
      {
        title: 'Footfall trend: Store vs Village',
        link: `${links.analytics}/store_vs_village-footfall`,
        slug: 'business_analytics/footfall_store_vs_village',
        withParams: true,
      },
      {
        title: 'Sales trend: Store vs Village',
        link: `${links.analytics}/store_vs_village-sales-trends`,
        slug: 'business_analytics/store_vs_village',
        withParams: true,
      },
      {
        title: 'Sales trend: Store vs Competitors',
        link: `${links.analytics}/invoices_sales_competitors`,
        slug: 'business_analytics/sales_competitors',
        withParams: true,
      },
      {
        title: 'KPIs brand cross village',
        link: `${links.analytics}/invoices_sales_trends`,
        slug: 'business_analytics/brand_cross_village',
        withParams: true,
      },
      {
        title: 'Sales tracking: age/gender',
        link: `${links.analytics}/sales_trackings_gender_age`,
        slug: 'business_analytics/gender_age',
        withParams: true,
      },
      {
        title: 'Sales tracking: brand/gender',
        link: `${links.analytics}/sales_trackings_gender_brand`,
        slug: 'business_analytics/gender_brand',
        withParams: true,
      },
      // {
      //   title: 'CRM Analytics',
      //   link: `${links.analytics}/vip_club`,
      //   slug: 'business_analytics/gender_brand',
      //   withParams: false,
      // },
      {
        title: 'Marketing',
        link: `${links.analytics}/vip_club`,
        slug: 'business_analytics/vip_club',
        withParams: true,
      },
      {
        title: 'SHOW ALL REPORTS',
        link: `${links.analytics}/export`,
        slug: 'business_analytics/all',
        withParams: true,
      },
    ],
  },
  {
    type: 'halfDone',
    Icon: YesOrNoIcon,
    title: 'Sondaggio',
    link: `${links.interviews}/interviews`,
    basePath: links.interviews,
    hideMain: true,
    slug: 'interviews',
    subLinks: [
      {
        title: 'Sondaggio a risposta chiusa',
        link: `${links.interviews}/interviews`,
        slug: 'interviews/interviews',
      },
      {
        title: 'Vota Best Store',
        link: `${links.interviews}/interview_store_pools`,
        slug: 'interviews/interview_store_pools',
      },
    ],
  },
  {
    type: 'done',
    Icon: ShoppingBagIcon,
    title: 'Smart Shopping',
    slug: 'click_collect',
    link: links.clickCollect,
    basePath: '/click_collect',
    main: 'Smart shopping',
    subLinks: [],
  },
  {
    type: 'halfDone',
    Icon: EuroIcon,
    title: 'Leasing',
    link: '/leasing/contact_role',
    basePath: '/leasing',
    hideMain: true,
    slug: 'leasing',
    subLinks: [
      {
        title: 'Ruoli contatti commerciali',
        link: '/leasing/contact_role',
        slug: 'leasing/contact_role',
      },
      {
        title: 'Asset di riferimento',
        link: '/leasing/asset',
        slug: 'leasing/asset',
      },
      {
        title: 'Leasing managers',
        link: '/leasing/manager',
        slug: 'leasing/contact',
      },
      {
        title: 'Elenco contatti commerciali',
        link: '/leasing/leasing_contacts',
        slug: 'leasing/contact',
      },
      {
        title: 'Unità',
        link: '/leasing/room',
        slug: 'leasing/room',
      },
      {
        title: 'Leasing plans',
        link: '/leasing/plans',
        slug: 'leasing/plans',
      },
      {
        title: 'Elenco incontri',
        link: '/leasing/visit_card',
        slug: 'leasing/visit_card',
      },
      {
        title: 'Tipo di incontro',
        link: '/leasing/meeting_types',
        slug: 'leasing/meeting_types',
      },
    ],
  },
  {
    type: 'halfDone',
    Icon: WebsiteIcon,
    title: 'Sito web',
    link: `${links.website}/homepage_slides`,
    basePath: links.website,
    hideMain: true,
    slug: 'website',
    main: 'Homepage slider',
    subLinks: [
      {
        title: 'Homepage slider',
        link: `${links.website}/homepage_slides`,
        slug: 'website/homepage_slides',
      },
      {
        title: 'Pagine statiche',
        link: `${links.website}/static_pages`,
        slug: 'website/static_pages',
      },
      // {
      //   title: 'Ristoranti',
      //   link: `${links.website}/restaurants`,
      //   slug: 'website/restaurants',
      // },
      {
        title: 'Itinerari turistici',
        link: `${links.website}/itineraries`,
        slug: 'website/itineraries',
      },
      {
        title: 'Partners',
        link: `${links.website}/partners`,
        slug: 'website/partners',
      },
      {
        title: 'Servizi',
        link: `${links.website}/services`,
        slug: 'website/services',
      },
      {
        title: 'QR',
        link: `${links.website}/web_qrs`,
        slug: 'website/web_qrs',
      },
      {
        title: 'In evidenza',
        link: `${links.website}/homepage_blocks`,
        slug: 'website/homepage_blocks',
      },
      {
        title: 'Landing Pages',
        link: `${links.website}/landing_pages`,
        slug: 'website/landing_pages',
      },
      {
        title: 'Slider loghi HP',
        link: `${links.website}/carousels`,
        slug: 'website/carousels',
      },
      {
        title: 'Footer menu',
        link: `${links.website}/footer_menus`,
        slug: 'website/footer_menus',
      },
    ],
  },
  {
    type: 'halfDone',
    Icon: InfoCircleOutlined,
    title: 'Loyalty / infopoint',
    link: '/leasing/contact_role',
    basePath: '/leasing',
    hideMain: true,
    slug: 'loyalty_infopoint',
    subLinks: [],
    openNewTab: true,
  },
];

export default pages;
